"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuCloseContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ActionMenuCloseContainer = styled_components_1.default.div `
  position: absolute;
  right: 5px;
  top: 0;
  display: inline-block;
`;
//# sourceMappingURL=action-menu-close-container.js.map